<template>
  <div id="store">
    <div class="title">
      <img src="@/assets/img/taiko/guide/header_1.png" alt="" />
      <img class="introduction" src="@/assets/img/taiko/guide/header_3.png" alt="" />
    </div>
    <div class="content">
      <div class="block">
        <div class="block_main_title">
          <img src="@/assets/img/taiko/guide/block_search.png" alt="" />
        </div>
        <div class="blcok_main_content">
          <span>所选地区</span>
          <span class="orange" @click="openModal">[ {{ province }} ▼ ]</span>
          <span>(店铺数{{ storeList.length }})</span>
        </div>
        <div class="block_data">
          <div class="block_data_item" v-for="item in storeList" :key="item.id">
            <div class="store_name">{{ item.store_name }}</div>
            <div class="store_address">{{ item.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="stars"></div>
      <!-- <img
        class="back"
        @click="scrollToTop"
        src="@/assets/img/taiko/guide/footer_back.png"
        alt=""
      /> -->
      <div class="bg">
        <img src="@/assets/img/taiko/guide/footer_bg.png" alt="" />
        <img src="@/assets/img/taiko/guide/footer_logo.png" alt="" />
      </div>
    </div>
    <modal ref="modal">
      <div class="province_list" :style="{ 'padding-top': `${(provinceList.length+1) * 0.59}rem` }">
        <div class="province_item" @click="filterProvince('所有')">所有</div>
        <div class="province_item" v-for="item in provinceList" :key="item.id" @click="filterProvince(item.province)">
          {{ item.province }}
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/StoreModal";
import storeList from "@/assets/data/store.json";

export default {
  name: "store",
  components: {
    Modal,
  },
  data() {
    return {
      storeList,
      provinceList: [],
      province: "所有",
      showDialog: false,
    };
  },
  mounted() {
    //去重省份
    const provinceList = Object.values(
      storeList.reduce((acc, obj) => {
        const { province } = obj;
        if (!acc[province]) {
          acc[province] = { ...obj };
        }
        return acc;
      }, {})
    );
    this.provinceList = provinceList;
    // console.log(this.provinceList);
  },

  methods: {
    filterProvince(province) {
      this.province = province;
      this.$refs.modal.close();
      if (province === "所有") {
        this.storeList = storeList;
        return;
      }
      this.storeList = storeList.filter((item) => {
        return item.province === province;
      });
    },
    openModal() {
      this.$refs.modal.open();
      document.body.style.overflow = 'hidden'
    },
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>